import { GitHubIcon } from "@gadgetinc/themes/src/icons/GitHubIcon";
import { ThirdPartyIcon } from "@gadgetinc/themes/src/icons/ThirdPartyIcon";
import { useStyletron } from "baseui";
import * as React from "react";
import { Button, SIZE } from "../edit/editor/Button";
import { getButtonStyles } from "./AuthLayout";

export const GoogleSignInButton = () => {
  const [css, $theme] = useStyletron();

  const linkStyling = css({
    color: $theme.colors.black,
    minWidth: "150px",
  });

  return (
    <Button
      $as="a"
      href="/auth/google"
      startEnhancer={<ThirdPartyIcon type="google" $size={20} />}
      overrides={{
        StartEnhancer: {
          style: { marginRight: $theme.sizing.scale600 },
        },
        BaseButton: {
          style: (innerProps) => ({
            ...getButtonStyles(innerProps, true),
            backgroundColor: $theme.colors.white,
            borderTopStyle: "solid",
            borderBottomStyle: "solid",
            borderLeftStyle: "solid",
            borderRightStyle: "solid",
            borderRightWidth: "1px",
            borderLeftWidth: "1px",
            borderBottomWidth: "1px",
            borderTopWidth: "1px",
            borderRightColor: "black",
            borderLeftColor: "black",
            borderBottomColor: "black",
            borderTopColor: "black",
            cursor: "pointer",

            ":focus": {
              backgroundColor: $theme.colors.primary100,
            },
            ":hover": {
              backgroundColor: $theme.colors.primary100,
            },
          }),
        },
      }}
    >
      <div className={linkStyling}>Continue with Google</div>
    </Button>
  );
};

export const GitHubSignInButton = () => {
  const [css, $theme] = useStyletron();

  return (
    <Button
      $as="a"
      href="/auth/github"
      overrides={{
        StartEnhancer: {
          style: { marginRight: $theme.sizing.scale600 },
        },
        BaseButton: {
          style: (innerProps) => ({
            ...getButtonStyles(innerProps, true),
          }),
        },
      }}
      startEnhancer={<GitHubIcon $size={20} />}
      size={SIZE.large}
    >
      <div
        className={css({
          minWidth: "150px",
        })}
      >
        Continue with GitHub
      </div>
    </Button>
  );
};
